(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrapbook-banner"] && !Shopify.designMode) return;
  try {
    
  // Singleton parallax manager with a single scroll listener
  const ParallaxManager = (() => {
    let elements = new Map(); // elm -> { baseOffset }
    let visibleElements = new Set();
    let ticking = false;
    let initialized = false;
    let observer = null;
    let mediaQuery = null;
    let resizeTimeout = null;

    function recalculateOffsets() {
      elements.forEach((data, elm) => {
        const rect = elm.getBoundingClientRect();
        data.baseOffset = rect.top + window.scrollY + rect.height / 2;
      });
    }

    function resetTransforms() {
      elements.forEach((data, elm) => {
        elm.style.transform = '';
      });
    }

    function updateParallax() {
      if (visibleElements.size === 0) return;
      if (!mediaQuery?.matches) return;

      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;

      visibleElements.forEach((elm) => {
        const data = elements.get(elm);
        if (!data) return;

        const strength = parseFloat(elm.dataset.parallaxStrength) || 0;
        const scrollCenter = scrollY + viewportHeight / 2;
        const relativeScroll = scrollCenter - data.baseOffset;
        const translateY = relativeScroll * strength;

        elm.style.transform = `translateY(${translateY}px)`;
      });
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    }

    function onResize() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        recalculateOffsets();
        updateParallax();
      }, 100);
    }

    function onBreakpointChange(e) {
      if (e.matches) {
        // Entered desktop: enable resize listener and parallax
        window.addEventListener('resize', onResize, { passive: true });
        recalculateOffsets();
        updateParallax();
      } else {
        // Entered mobile: disable resize listener and reset transforms
        window.removeEventListener('resize', onResize);
        resetTransforms();
      }
    }

    function onIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visibleElements.add(entry.target);
        } else {
          visibleElements.delete(entry.target);
        }
      });
      updateParallax();
    }

    function init() {
      if (initialized) return;

      mediaQuery = window.matchMedia('(min-width: 1024px)');
      mediaQuery.addEventListener('change', onBreakpointChange);

      // Set up resize listener if already on desktop
      if (mediaQuery.matches) {
        window.addEventListener('resize', onResize, { passive: true });
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      observer = new IntersectionObserver(onIntersection, {
        rootMargin: '50% 0px'
      });
      initialized = true;
    }

    return {
      register(elm) {
        init();
        // Store the element's initial offset from the top of the document
        const rect = elm.getBoundingClientRect();
        const baseOffset = rect.top + window.scrollY + rect.height / 2;
        elements.set(elm, { baseOffset });
        observer.observe(elm);
      },
      unregister(elm) {
        elements.delete(elm);
        visibleElements.delete(elm);
        if (observer) observer.unobserve(elm);
      }
    };
  })();

  class ScrapbookBanner extends HTMLElement {
    mediaElements; // NodeList<HTMLElement>
    observer; // IntersectionObserver
    onIntersectionBound;
    prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    constructor() {
      super();
    }

    connectedCallback() {
      this.mediaElements = this.querySelectorAll('.js-scrapbookBanner__mediaInner');
      this.onIntersectionBound = this.onIntersection.bind(this);

      this.observer = new IntersectionObserver(this.onIntersectionBound, { rootMargin: '-10% 0px -20% 0px' });
      
      if (!this.prefersReducedMotion) {
        this.mediaElements.forEach(elm => {
          this.observer.observe(elm);
          ParallaxManager.register(elm);
        });
      }
    }

    disconnectedCallback() {
      this.observer.disconnect();

      if (!this.prefersReducedMotion) {
        this.mediaElements.forEach(elm => {
          ParallaxManager.unregister(elm);
        });
      }
    }

    onIntersection(elements) {
      elements.forEach((entry) => {
        if (entry.isIntersecting) {
          this.observer.unobserve(entry.target);
          entry.target.classList.add('anim');
        }
      });
    }
  }

  customElements.define('scrapbook-banner', ScrapbookBanner);

  } catch(e) { console.error(e); }
})();
})();
